
<template>
  <div>
    <template v-if="!wapShow">
    <header1 :menuIndex="1"></header1>
    <div class="solution-banner">
      <div class="app-content" ref="testref">
        <div class="solution-title">体系化·高效化·科学化</div>
        <div class="solution-title2">依托于一套完备的预应力工程全数量无人化检测装备体系，实现质量评价体系化、控制管理高效化、品质提升科学化</div>
      </div>
    </div>
    <div class="solution-content">
      <div class="app-content">
        <div class="title1" ref="test2ref" id="index1" :class="{'title-s1':testShow2}">行业挑战</div>
        <div class="solution-content-ul flex-sp" >
          <div class="solution-content-li" :class="{'title-s1':testShow2}">
            <div class="san"></div>
            <div class="san1">1</div>
            <div class="t1">工程行业特点与挑战</div>
            <div class="t2" style="margin-top: 49px">特点</div>
            <div class="t3">基建大国。</div>
            <div class="t3">数量多、规模大、进步快</div>

            <img src="@/assets/imgs/solution/2.png" />
            <div class="t2" style="margin-top: 84px">挑战</div>
            <div class="t3">劳动生产效率低、产值利润率低</div>
            <div class="t3">资源消耗大、浪费现象严重</div>
            <div class="t3">劳动环境恶劣（危、繁、重、苦）</div>
          </div>
          <div class="solution-content-li" :class="{'title-s1':testShow2}">
            <div class="san"></div>
            <div class="san1">2</div>
            <div class="t1">预应力工程行业特点与挑战</div>
            <div class="t2" style="margin-top: 49px">特点</div>
            <div class="t3" style="margin-bottom: 10px">技术经济优势显著</div>
            <div class="t3" style="margin-bottom: 10px;margin-top: 16px">应用领域广泛、发展进步迅速</div>

            <img style="margin-top: 40px" src="@/assets/imgs/solution/2.png" />
            <div class="t2" style="margin-top: 40px">挑战</div>
            <div class="t3">专业性强、工艺工序多、技术要求高</div>
            <div class="t3">隐蔽性强、质量控制难</div>
            <div class="t3">应用需求差异化大、技术发展不平衡</div>
            <div class="t3">质量安全隐患多、事故责任重、损失影响大</div>
          </div>
          <div class="solution-content-li" :class="{'title-s1':testShow2}">
            <div class="san"></div>
            <div class="san1">3</div>
            <div class="t1">预应力工程质量检测行业机遇</div>
            <div class="t2" style="margin-top: 49px">机遇</div>
            <div class="t3">行业发展转型升级，迫切需要实现高质量发展，打造品质工程</div>
            <div class="t3">新一轮数字科技革命将为工程建设行业带来新的创新驱动力</div>
            <div class="t3">新一代信息技术与检测技术的深度融合将彻底变革传统工程检测模式</div>

            <img style="margin-top: 5px" src="@/assets/imgs/solution/2.png"  />
            <div class="t2" style="margin-top: 0px">挑战</div>
            <div class="t3">理论、技术、规范体系还尚待完善</div>
<!--            <div class="t3">工程建设体量大，地形地质条件复杂，工点多，线路长，-->
<!--              分散广，集中管理难</div>-->
            <div class="t3">预应力专项作业技术要求高、工况环境差、危险系数大</div>
            <div class="t3">重要工艺环节隐蔽性强、时间窗口窄，传统方式检不了、
              检不准、检得慢、费用高</div>
<!--            <div class="t3">整体上呈现“漏洞大、风险高、效率低”的特征性问题</div>-->
            <div class="t3">参建各方均面临“决策层看不清、管理层管不住、执行层做不好”的突出问题</div>
          </div>
        </div>
      </div>
    </div>

    <div class="solution-content1" style="margin-top: 54px;    position: relative;">
      <div class="app-content" style="position: absolute;left: 0;top: 39px;z-index: 4;right: 0;text-align: center">
        <div class="content1-t1">解决方案体系</div>
        <div class="content1-t2" style="text-align: left">在国家全面开展质量提升行动，实施质量强国战略时代背景下，顺应新基建“数字化、网络化、智能化”三化融合的发展趋势，为从本质上杜绝重大质量事故和隐患，满足品质工程建设的需要，基于新发展理念，利用新技术和新装备，深度融合现代信息技术，构筑了一套以数字化为核心的“体系化、高效化、科学化”解决方案。</div>
       </div>
      <img src="@/assets/imgs/solution/1.png" style="width: 100%" />
    </div>

    <div class="solution-content2">
      <div class="app-content">
        <div class="content2-title2" id="index2">方案优势</div>
        <div class="solution-content2-li flex">
          <img src="@/assets/imgs/solution/5.png"  style="transform: rotateZ(180deg);left: 0;top: 0;">
          <div class="left">
            <div class="left-li1">过程阶段</div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/yes.png" /><span style="margin-left: 16px">测量记录</span></div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/yes.png" /> <span style="margin-left: 11px">结果评价</span></div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/yes.png" /> <span style="margin-left: 11px">质量控制</span></div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/yes.png" /> <span style="margin-left: 11px">品质提升</span></div>
          </div>
          <div class="center-header">数字化方案</div>
          <div class="center">
            <div class="center-li1">实施方式</div>
            <div  class="center-li2">物联网（IOT）终端远程自动采集</div>
            <div  class="center-li2">施工过程中全数量动态检测</div>
            <div  class="center-li2">云平台实时数据驱动和自动事件预警</div>
            <div  class="center-li2">大数据全维度智能分析、决策及响应</div>
          </div>
          <div class="center" style="border-left:1px solid #eeeeee">
            <div class="center-li1">优点</div>
            <div  class="center-li2">实时、完整、客观、无人</div>
            <div  class="center-li2">事中、全样、动态、节约</div>
            <div  class="center-li2">协同、及时、闭环、高效</div>
            <div  class="center-li2">全面、精准、持续、透明( 不隐瞒、不回避、不盲动）</div>
          </div>
        </div>

        <div class="solution-content2-li flex" style="margin-top: 32px">
          <img src="@/assets/imgs/solution/5.png" style="    left: 164px;bottom: 0;">
          <div class="left">
            <div class="left-li1">过程阶段</div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/no.png" /><span style="margin-left: 16px">测量记录</span></div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/no.png" /> <span style="margin-left: 11px">结果评价</span></div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/no.png" /> <span style="margin-left: 11px">质量控制</span></div>
            <div class="left-li2"><img style="width: 19px;position: relative;top: 3px;" src="@/assets/imgs/solution/no.png" /> <span style="margin-left: 11px">品质提升</span></div>
          </div>
          <div class="center-header">传统方案</div>
          <div class="center">
            <div class="center-li1">实施方式</div>
            <div  class="center-li2">人工旁站监管记录</div>
            <div  class="center-li2">施工完后再现场抽样检测</div>
            <div  class="center-li2">依赖经验、责任感及强制措施</div>
            <div  class="center-li2">事后流程业务驱动</div>
          </div>
          <div class="center" style="border-left:1px solid #eeeeee">
            <div class="center-li1">缺点</div>
            <div  class="center-li2">粗放、碎片、主观</div>
            <div  class="center-li2">费时、费力、费钱</div>
            <div  class="center-li2">片面、波动、隐蔽</div>
            <div  class="center-li2">迟滞、漏环、低效</div>
          </div>
        </div>
      </div>
    </div>


    <div class="solution-content3" style="position: relative;overflow: hidden;">
      <div class="solution-content3-left">
      </div>
      <div class="solution-content3-right"></div>
      <img class="solution-content3-right1" src="@/assets/imgs/solution/4.png" />
      <div class="app-content flex-sp" id="index3">
        <div>
          <div class="content3-t1">方案价值</div>
          <div class="flex" style="margin-top: 24px">
            <div class="content3-t2">
              <span>价值层面</span>
              <span>质量评价</span>
              <span>控制管理</span>
              <span>品质提升</span>
            </div>
            <div class="content3-t2">
              <span>意义导向</span>
              <span>体系化</span>
              <span>高效化</span>
              <span>科学化</span>
            </div>
            <div class="content3-t2">
              <span>呈现方式</span>
              <span>六位一体、全时全维、客观真实</span>
              <span>施工即检测、动态反馈、预警实时、处理及时、有效闭环</span>
              <span>精准定位问题、科学分析研判原因、落实质量提升行动</span>
            </div>
          </div>
        </div>
        <div>
          <div class="content3-t3">解决方案咨询</div>
          <div class="content3-t4">关于解决方案的更多咨询， 请联系我们的销售
            和技术支持团队</div>
          <router-link to="/contactUs">
          <div class="content3-t5 flex-center">联系我们</div>
          </router-link>
        </div>

      </div>
    </div>
    <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>


<script type="text/javascript">
  import wapIndex from "./wapIndex"
  import header1 from "@/components/header1"
  import footers from "@/components/footers"
  import eventBus from "../../assets/js/eventBus";

  export default {
    name: 'solution',
    components:{header1,footers,wapIndex},
    data(){
      return{
        testShow:false,
        testShow2:false,
        wapShow:false
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
        if(!this.wapShow) {
          this.$nextTick(() => {
            if( document.querySelector("#" + this.$route.query.index)){
              document.querySelector("#" + this.$route.query.index).scrollIntoView(true);
            }
          })
          window.addEventListener('scroll', this.handleScrollbox, true)
        }
      })

    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScrollbox, true)
    },
    methods:{
      handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        if(this.$refs.testref){
          if (this.currentScroll >= this.$refs.testref.offsetTop - 600) {
            //当前滚动位置到达testref的时候，显示div（100作为调整用）
            this.testShow = true
          }
        }
        if(this.$refs.test2ref) {
          if (this.currentScroll >= this.$refs.test2ref.offsetTop - 600) {
            this.testShow2 = true
          }
        }
      },
    }

  }
</script>

<style scoped>
  .solution-banner{
    width: 100%;
    background-image: url("../../assets/imgs/solution/6.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 560px;
    margin-top: 80px;
    background-color: #F2F4F9;
    overflow: hidden;

  }
 .title-s1{
   animation-name: fadeInUp;
   animation-duration:2s;
   animation-timing-function:ease;
   animation-fill-mode:forwards;
    visibility: visible;
   opacity: 1;
  }
  .solution-banner .solution-title{
    font-size: 38px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    margin-top: 90px;
    color: #19203B;
    animation-name: fadeInUp;
    opacity: 0;
    animation-duration:1s;
    font-weight: bold;
    letter-spacing: 6px;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
  }
  .solution-banner .solution-title2{
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgba(92, 93, 95, 1);
    width: 704px;
    line-height: 2;
    letter-spacing: 4px;
    opacity: 0;
    animation-name: fadeInUp;
    animation-duration:1s;
    animation-delay: 1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    margin-top: 56px;
  }
  .solution-content{
    padding-top: 64px;
  }
  .solution-content .title1{
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    opacity: 0;
    text-align: center;
    margin-bottom: 50px;
  }
  .solution-content .solution-content-li{
    width: 389px;
    height: 701px;
    background-color: #F1F3F9;
    padding-top: 43px;
    opacity: 0;
    box-sizing: border-box;
    position: relative;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid rgba(0,0,0,0);
    cursor: pointer;
  }
  .solution-content .solution-content-li img{
    width: 60px;
    height: 60px;
    margin-top: 69px;
    margin-left: 174px;
  }
  .solution-content .solution-content-li .t1{
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: center;
  }
  .solution-content .solution-content-li .san{
    background-image: url("../../assets/imgs/solution/7.png");
    position: absolute;
    height: 70px;
    width: 70px;
    top: 0;
    background-size: 100%;
    left: 0;

  }
  .solution-content .solution-content-li .san1{
    position: absolute;
    color: #ffffff;
    left: 13px;
    top: 3px;
    font-size: 22px;
  }
  .solution-content .solution-content-li .t2{
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    margin-left: 20px;
    margin-bottom: 16px;
  }
  .solution-content .solution-content-li .t3{
    font-size: 14px;
    position: relative;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    width: 303px;
    margin-left: 20px;
    margin-bottom: 10px;
    padding-left: 20px;
  }
  .solution-content .solution-content-li .t4{
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    width: 303px;
    color: #5C5D5F;
    margin-left: 36px;
    margin-bottom: 10px;
  }
  .solution-content .solution-content-li .t3:after{
    width: 10px;
    content: " ";
    position: absolute;
    height: 10px;
    background: #0071EF;
    left: 0;
    border-radius: 5px 5px 5px 5px;
    top: 6px;
  }
  .solution-content .solution-content-li:hover{
    background: linear-gradient(135deg, rgba(52, 228, 170, 0.32) 0%, hsla(223, 100%, 59%, 0.32) 100%);
  }


  .solution-content1 .content1-t1{
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #0071EF;
  }
  .solution-content1 .content1-t2{
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #0071EF;
    line-height: 2;
    margin-top: 40px;
  }

  .solution-content2{
    width: 100%;
    height: 915px;
    background: #F2F4F9;
    overflow: hidden;
    margin-top: 51px;
  }
  .solution-content2 .solution-content2-li{
    position: relative;
  }
  .solution-content2 .solution-content2-li img{
    position: absolute;
    width: 164px;
  }
 .solution-content2 .solution-content2-li .left{
   width: 320px;
   height: 320px;
   background-color: #0071EF;
   color: #ffffff;
  }
  .solution-content2 .solution-content2-li .center{
    width: 558px;
    height: 320px;
    background-color: #FFFFFF;
  }
  .solution-content2 .solution-content2-li .center .center-li1{
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    margin-top: 70px;
    margin-left: 29px;
  }
  .solution-content2 .solution-content2-li .center .center-li2{
    margin-top: 20px;
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #19203B;
    margin-left: 29px;
  }
  .solution-content2 .solution-content2-li .left-li1{
    margin-top: 73px;
    margin-left: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #F2F2F2;
  }
  .solution-content2 .solution-content2-li .left-li2{
    font-size: 18px;
    margin-top: 21px;
    margin-left: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #F2F2F2;
  }

  .solution-content2 .content2-title2 {
    margin:64px 0;
    text-align: center;
    font-size: 40px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }
  .center-header{
    height: 51px;
    background: #0071EF;
    width: 926px;
    position: absolute;
    left: 274px;
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #F2F2F2;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .solution-content3{
    margin-top: 50px;
    position: relative;
  }
  .solution-content3 .app-content{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .solution-content3 .content3-t1{
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #F2F2F2;
    margin-top: 90px;
  }
  .solution-content3 .content3-t2{
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-right: 44px;
  }

  .solution-content3 .content3-t3{
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #F2F2F2;
    margin-top: 140px;
  }
  .solution-content3 .content3-t4{
    width: 383px;
    margin-top: 31px;
    line-height: 2;
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;

  }
  .solution-content3 .content3-t5{
    width: 176px;
    height: 52px;
    background: linear-gradient(33deg, #34E4AA 0%, #2C68FF 100%);
    border-radius: 88px 88px 88px 88px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 42px;
    cursor: pointer;
  }
  .solution-content3 .content3-t2 span{
    display: block;
    margin-bottom: 34px;
  }
  .solution-content3 .solution-content3-left{
    width: 80%;
    height: 492px;
    left: -10%;
    top: 0;
    background: linear-gradient(154deg, #34E4AA 0%, #2C68FF 100%);
  }
  .solution-content3 .solution-content3-right{
    background-color: #19203B;
    height: 492px;
    position: absolute;
    right: -16%;
    top: 0;
    width: 40%;
  }

  .solution-content3 .solution-content3-right1{
    height: 492px;
    position: absolute;
    left:41%;
    top: 0;
  }
  a{
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/solution/index.vue